module.exports = __webpack_public_path__ + "static/media/team-default-log.f57fd06f.png";